module.exports = __webpack_public_path__ + "img/streamline-icon-house-1@450x450.3f6d3a27.svg";